import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AIDefinitionsPlugin } from '../../aiDefinitionsPluginType';

export function getLivePageMode({
	api,
}: {
	// api is mandatory but can be undefined
	api: ExtractInjectionAPI<AIDefinitionsPlugin> | undefined;
}) {
	return api?.editorViewMode.sharedState.currentState()?.mode;
}

/**
 * see comments in `AIDefinitionsPluginConfig` for more details about why not checking `isLivePage` here
 */
export function isLivePageViewMode({
	api,
}: {
	// api is mandatory but can be undefined
	api: ExtractInjectionAPI<AIDefinitionsPlugin> | undefined;
}) {
	const livePageMode = getLivePageMode({ api });
	return livePageMode === 'view';
}
